import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-header-item',
  templateUrl: './header-item.component.html',
  styleUrls: ['./header-item.component.scss'],
  imports: [
    MatIcon,
    CdkOverlayOrigin,
    MatTooltip,
    CdkConnectedOverlay,
    MatCard,
    MatCardContent,
    NgClass,
    MatIconButton,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderItemComponent implements OnInit, OnDestroy {
  private document = inject<Document>(DOCUMENT);

  label = input<string>();
  value = input<any>();
  icon = input<string>();
  hover = input<string>();
  readonly = input<boolean>();
  noPadding = input<boolean>(false);
  noEllipsis = input<boolean>(false);
  isClosed = input<boolean>();
  headerTooltip = input<string>();
  openChange = output<boolean>();

  isOpen = false;

  readonly overlayPositions: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
  ];

  subscription = toObservable(this.isClosed)
    .pipe(takeUntilDestroyed())
    .subscribe((isClosed) => {
      if (isClosed) {
        this.isOpen = false;
        this.openChange.emit(this.isOpen);
      }
    });

  onClickValue() {
    if (this.readonly()) return;
    this.isOpen = !this.isOpen;
    this.openChange.emit(this.isOpen);
  }

  onClose() {
    this.isOpen = false;
    this.openChange.emit(this.isOpen);
  }

  ngOnInit() {
    this.document.addEventListener('keyup', this.onKeyup.bind(this));
  }

  get placeholderName() {
    if (this.readonly()) return '';
    return 'Select';
  }

  ngOnDestroy() {
    this.document.removeEventListener('keyup', this.onKeyup.bind(this));
  }

  onKeyup(event: KeyboardEvent) {
    if (this.isOpen && event.key === 'Enter') {
      this.isOpen = false;
      this.openChange.emit(this.isOpen);
    }
  }
}
